import { render, staticRenderFns } from "./OrganisationSelect.vue?vue&type=template&id=996fb2c6&"
import script from "./OrganisationSelect.vue?vue&type=script&lang=js&"
export * from "./OrganisationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports